// src/utils/filters.js
import { STATUS } from './careerLogic';

export const isFromCPCOnwards = (materia) => {
  if (!materia) return false;
  return materia.categoria && String(materia.categoria).toUpperCase() !== 'CBC';
};

export const estadoOrder = (estado) => {
  switch (estado) {
    case STATUS.CURSADA_APROBADA:
      return 0; // Aprobadas arriba
    case STATUS.PUEDE_CURSAR:
      return 1; // Habilitadas
    case STATUS.CURSANDO:
      return 2; // En curso
    case STATUS.NO_CURSADA:
      return 3; // Abajo
    default:
      return 4;
  }
};

export const sortByEstadoThenNombre = (a, b) => {
  const byEstado = estadoOrder(a.estado) - estadoOrder(b.estado);
  if (byEstado !== 0) return byEstado;
  return String(a.nombre || '').localeCompare(String(b.nombre || ''));
};

export const formatFechaDisplay = (fecha) => {
  if (!fecha) return '';
  const [y, m] = String(fecha).split('-');
  if (!y || !m) return '';
  return `${m}/${y}`;
};

export const buildFechaFromMonthYear = (month, year) => {
  if (!month || !year) return '';
  // Guardar día fijo para compatibilidad con Date
  const mm = String(month).padStart(2, '0');
  return `${year}-${mm}-01`;
};

export const splitFechaToMonthYear = (fecha) => {
  if (!fecha) return { month: '', year: '' };
  const [y, m] = String(fecha).split('-');
  return { month: m || '', year: y || '' };
};


